import SmartObject from '../objects/SmartObject';
import ShapeDrawingBrush, {
  type CreateObjectOptions,
} from './ShapeDrawingBrush';

const DEFAULT_WIDTH = 300;
const DEFAULT_HEIGHT = 300;

// Brush for drawing smart objects.
class SmartObjectDrawingBrush extends ShapeDrawingBrush {
  _createObject(options: CreateObjectOptions, drawing: boolean) {
    const controller = this.canvas.controller;

    const object = new SmartObject({
      controller,
      ...controller.defaultsManager.for('frame'),
      ...options,

      ...(drawing
        ? {
            scaleX: 0.05,
            scaleY: 0.05,
          }
        : {}),

      textContent: `cycle\n\nOne\nTwo\nThree`,
      width: DEFAULT_WIDTH,
      height: DEFAULT_HEIGHT,
    });

    return controller.addToCanvas(object);
  }
}

export default SmartObjectDrawingBrush;
